// Single source of truth for the M9 ProductionOrder workshop step list on
// the frontend - same literal strings as the backend's
// productionOrderModel.js enum (the DB value IS the display text, see that
// file for why). Shared between ProductionOrders.js and
// ProductionCycleTimeline so the two never drift apart.
export const STATUS_ORDER = [
  "Lancement du tracé + préparation du fichier",
  "Coupe (sous-traitance)",
  "Tirage film",
  "Impression",
  "Fourniture (billet, côte, emballage, élastique)",
  "Livré (vers un autre atelier)",
  "Confection",
  "Contrôle qualité",
];

export const TERMINAL_STATUS = "Contrôle qualité";

// The one step that's easy to confuse with client delivery - it's an
// internal handoff to another workshop, not Order.status "livré".
export const HANDOFF_STATUS = "Livré (vers un autre atelier)";

export const nextStatus = (status) => {
  const idx = STATUS_ORDER.indexOf(status);
  return idx >= 0 && idx < STATUS_ORDER.length - 1 ? STATUS_ORDER[idx + 1] : null;
};
